var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "camere-selector-item" }, [
    _c("div", { staticClass: "d-flex justify-content-between mb-2" }, [
      _c("h4", [_vm._v(_vm._s(_vm.title))])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex justify-content-between mb-2" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("InputIncrement", {
            attrs: { value: _vm.info.adults, min: 1, disabled: _vm.disabled },
            on: { change: _vm.onAdultChange }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex justify-content-between mb-2" }, [
      _vm._m(1),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("InputIncrement", {
            attrs: { value: _vm.info.childs.length, disabled: _vm.disabled },
            on: { change: _vm.onChildChange }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _vm.info.childs.length > 0
      ? _c("div", [
          _vm._m(2),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ages row no-gutters pt-2" },
            _vm._l(_vm.info.childs, function(child, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "col-4 mb-1",
                  attrs: { value: child }
                },
                [
                  _c(
                    "select",
                    {
                      staticClass: "form-control",
                      attrs: { index: index },
                      on: { change: _vm.onEtaChange }
                    },
                    _vm._l(_vm.eta, function(item) {
                      return _c(
                        "option",
                        {
                          key: item,
                          domProps: {
                            value: item,
                            selected: item === child.eta
                          }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(item) +
                              "\n                    "
                          )
                        ]
                      )
                    }),
                    0
                  )
                ]
              )
            }),
            0
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [_vm._v("Adulti")]),
      _vm._v(" "),
      _c("small", [_vm._v("almeno 18 anni")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [_vm._v("Bambini")]),
      _vm._v(" "),
      _c("small", [_vm._v("meno di 18 anni")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("età dei bambini "),
      _c("small", [_vm._v("(anni compiuti)")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-30e4f151", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30e4f151","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/common/camere-selector/CamereSelectorItem.vue
// module id = null
// module chunks = 